import React from 'react';
import { ConfigurationContext } from './configuration-context';
export function useConfiguration() {
    return React.useContext(ConfigurationContext);
}
//# sourceMappingURL=use-configuration.js.map